module.exports = [
  require('./ice_devil'),
  require('./ice_mephit'),
  require('./incubus'),
  require('./imp'),
  require('./intellect_devourer'),
  require('./invisible_stalker'),
  require('./iron_golem'),
]
